/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PropertyStatusEnum } from './propertyStatusEnum';
import { PropertyTypeEnum } from './propertyTypeEnum';


export interface PropertyResource { 
    id: number;
    /**
     * The type of the property. ApartmentForSale(1), ApartmentForRent(2), FamilyHouse(3), Land(4), OtherBuilding(5).
     */
    type: PropertyTypeEnum;
    /**
     * The status of the property. Draft(0), Completed(1).
     */
    status: PropertyStatusEnum;
    /**
     * The user id.
     */
    userId: number | null;
    /**
     * The external user id.
     */
    externalUserId: number | null;
    data: string;
    completedAt: string | null;
    createdAt: string | null;
    updatedAt: string | null;
}
export namespace PropertyResource {
}


